module.exports = __webpack_public_path__ + "img/0005.d6ecdcc8.png";